<template>
  <div>
    <ca-row>
      <ca-col size="2">
        <ca-button
          full-width
          @click="onEdit(jobDescription.id)">
          Editar
        </ca-button>
      </ca-col>
      <ca-col size="2">
        <ca-button
          full-width
          @click="onDelete(jobDescription.id)">
          Excluir
        </ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-page>
          <ca-async-content-wrapper
            :on-fetch="getJobDescription"
            :on-fetch-success="setJobDescription">
            <div v-if="jobDescription">
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Descrição">
                    {{ jobDescription.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="CBO">
                    {{ jobDescription.cbo }}
                  </ca-field>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="CNPJ do Sindicato da Categoria">
                    {{ jobDescription.categoryUnionCnpj }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col size="4">
                  <ca-field label="Compartilhado">
                    {{ jobDescription.shared ? 'Sim' : 'Não' }}
                  </ca-field>
                </ca-col>
              </ca-row>
            </div>
          </ca-async-content-wrapper>
        </ca-page>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import {
  DELETE_TITLE, DELETE_MESSAGE, DELETE_CONFIRM_TEXT, DELETE_SUCCESS_MESSAGE,
} from './constants';
import { getJobDescription, deleteJobDescription } from './jobDescriptionService';

export default {
  name: 'JobDescriptionsViewPage',
  data() {
    return {
      jobDescription: null,
    };
  },
  computed: {
  },
  methods: {
    getJobDescription() {
      return getJobDescription(this.$route.params.id);
    },
    setJobDescription(jobDescription) {
      this.jobDescription = jobDescription;
    },
    onEdit(id) {
      this.$router.push({ name: 'EditJobDescription', params: { id } });
    },
    onDelete(id) {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: DELETE_CONFIRM_TEXT,
        onConfirm: () => {
          deleteJobDescription(id)
            .then(() => {
              this.$toaster.success(DELETE_SUCCESS_MESSAGE);
              this.$router.back();
            })
            .catch(e => {
              this.$toaster[e.status](e.message);
            });
        },
      });
    },
  },
};
</script>
